import { Auth } from 'aws-amplify';
import { GaAnalytics } from '../analytics';

import { setAuthCookies } from '../cookies-management';

export interface OAuthDataType {
  token: string,
  userId: string,
  social: string,
  expiresAt: number,
  name: string
}

type SignInUser = {
  username: string,
  password: string
};

export async function signIn({ username, password }: SignInUser): Promise<void | unknown> {
  try {
    const user = await Auth.signIn(username, password);
    const { signInUserSession: { idToken, accessToken, refreshToken }, attributes: { sub } } = user;
    setAuthCookies({ idToken, accessToken, refreshToken: refreshToken.token, uid: sub });
    GaAnalytics.sendEvent('login');
  } catch (error) {
    // HANDLE ERRORS
    return ({ error });
  }
}

export async function oAuthSignIn(data: OAuthDataType): Promise<void> {
  const { social, token, expiresAt, name } = data;
  const federatedResponse = {
    token,
    expires_at: expiresAt,
  };
  const user = {
    name,
  };

  const loginUser = async () => {
    await Auth.federatedSignIn(social, federatedResponse, user)
      .then(() => {
        return Auth.currentAuthenticatedUser()
          .then(userData => console.log('userData', userData))
          .catch(() => console.log('Not signed in'));
      },
      );
  };
  loginUser();
}
